import { LocalTrack, LocalVideoTrack, RemoteAudioTrack, RemoteTrack, RemoteVideoTrack } from "twilio-video"

export const isAttachableRemoteTrack = (track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack => {
  return !!track && (track.kind === "video" || track.kind === "audio") && track.attach !== undefined
}

export const isDetachableRemoteTrack = (track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack => {
  return !!track && (track.kind === "video" || track.kind === "audio") && track.detach !== undefined
}

export const isAttachableLocalTrack = (track: LocalTrack | undefined): track is LocalVideoTrack => {
  return !!track && (track.kind === "video" || track.kind === "audio") && track.attach !== undefined
}

export const isDetachableLocalTrack = (track: LocalTrack | undefined): track is LocalVideoTrack => {
  return !!track && (track.kind === "video" || track.kind === "audio") && track.detach !== undefined
}
